// extracted by mini-css-extract-plugin
export var container = "styles-module__container___snKKn";
export var disabled = "styles-module__disabled___ci8Ip";
export var iconContainer = "styles-module__iconContainer___QYSBk";
export var link = "styles-module__link___SVH8o";
export var plusBadge = "styles-module__plusBadge___satvW";
export var title = "styles-module__title___ZCFbD";